/* Visivio — motion for devices with no cursor.

   On a phone the only input the page reliably gets is scroll, so scroll
   drives the hero field and the card perspective. Device tilt layers on top
   where it is available and permitted, and takes over while the phone moves.

   Deliberately NOT used: finger-drag on page content. The interaction
   guidance is explicit that custom horizontal gestures on main content
   collide with system back/scroll. */
(function () {
  'use strict';
  if (window.__vvMobile) return;
  window.__vvMobile = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* desktop already has a cursor — leave it alone */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var TILT_MAX = 4.5;      /* degrees on cards — subtle; this is a shop */
  var cards = [];
  var gyroOn = false;
  var gx = 0, gy = 0;      /* target from gyro */
  var sx = 0, sy = 0;      /* target from scroll */
  var cx = 0, cy = 0;      /* smoothed, what we actually apply */
  var raf = null, dirty = true;
  var vh = window.innerHeight;

  /* scratch buffers, reused every frame so the loop allocates nothing */
  var visible = [], leans = [];

  function collect() {
    cards = [];
    Array.prototype.forEach.call(
      document.querySelectorAll('.vv-card, .vv-step, .vv-pc'),
      function (el) { el.classList.add('vv-mtilt'); cards.push(el); }
    );
  }

  /* ---- scroll: page position becomes a slow drift ---- */
  function onScroll() {
    var h = document.documentElement.scrollHeight - vh;
    var p = h > 0 ? window.pageYOffset / h : 0;
    sx = Math.sin(p * Math.PI * 2) * 0.55;
    sy = (p - 0.5) * 1.1;
    dirty = true;
    schedule();
  }

  function onResize() {
    vh = window.innerHeight;
    onScroll();
  }

  /* ---- device tilt ---- */
  function onOrient(e) {
    if (e.gamma === null && e.beta === null) return;
    gyroOn = true;
    var g = e.gamma || 0;                     /* left/right, -90..90 */
    var b = (e.beta === null ? 45 : e.beta);  /* front/back */
    gx = Math.max(-1, Math.min(g / 32, 1));
    gy = Math.max(-1, Math.min((b - 45) / 32, 1));
    dirty = true;
    schedule();
  }

  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(tick);
  }

  function tick() {
    raf = null;
    /* tilt wins while the phone is actually moving; scroll is the fallback */
    var tx = gyroOn ? gx : sx;
    var ty = gyroOn ? gy : sy;

    cx += (tx - cx) * 0.12;
    cy += (ty - cy) * 0.12;

    if (window.vvField && window.vvField.setPointer) {
      window.vvField.setPointer(cx, cy);
    }

    /* Read every position first, write every style after. Interleaving the
       two forces the browser to recompute layout once per card, which is
       what made scrolling stutter on a long page. */
    visible.length = 0;
    leans.length = 0;
    for (var i = 0; i < cards.length; i++) {
      var r = cards[i].getBoundingClientRect();
      if (r.bottom < -80 || r.top > vh + 80) continue;
      /* how far the card sits from the middle of the screen, -1..1 */
      var mid = (r.top + r.height / 2) / vh;
      visible.push(cards[i]);
      leans.push(Math.max(-1, Math.min((0.5 - mid) * 2, 1)));
    }

    var ry = (cx * TILT_MAX * 0.8).toFixed(2) + 'deg';
    for (var k = 0; k < visible.length; k++) {
      visible[k].style.setProperty('--vv-rx', (leans[k] * TILT_MAX).toFixed(2) + 'deg');
      visible[k].style.setProperty('--vv-ry', ry);
    }

    if (Math.abs(tx - cx) > 0.002 || Math.abs(ty - cy) > 0.002 || dirty) {
      dirty = false;
      schedule();
    }
  }

  /* ---- wiring ---- */
  function attachOrientation() {
    window.addEventListener('deviceorientation', onOrient, { passive: true });
  }

  function needsPermission() {
    return typeof window.DeviceOrientationEvent !== 'undefined'
      && typeof window.DeviceOrientationEvent.requestPermission === 'function';
  }

  function askButton() {
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('vvMotionAsk') === 'no'; } catch (e) {}
    if (dismissed) return;

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'vv-motion-ask';
    b.innerHTML = '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
      '<rect x="6" y="2.5" width="8" height="15" rx="2" stroke="currentColor" stroke-width="1.6"/>' +
      '<path d="M2.6 7.5a7 7 0 0 0 0 5M17.4 7.5a7 7 0 0 1 0 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
      '</svg>Włącz ruch';
    b.addEventListener('click', function () {
      window.DeviceOrientationEvent.requestPermission().then(function (res) {
        if (res === 'granted') { attachOrientation(); }
        else { try { sessionStorage.setItem('vvMotionAsk', 'no'); } catch (e) {} }
        b.classList.remove('is-in');
        setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 360);
      }).catch(function () {
        b.classList.remove('is-in');
        setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 360);
      });
    });
    document.body.appendChild(b);
    /* let the page settle before asking for anything */
    setTimeout(function () { b.classList.add('is-in'); }, 1600);
  }

  function init() {
    collect();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    onResize();

    if (needsPermission()) { askButton(); }
    else if (typeof window.DeviceOrientationEvent !== 'undefined') { attachOrientation(); }

    /* if the phone is flat on a table, gyro stays quiet and scroll keeps working */
    setTimeout(function () { if (!gyroOn) schedule(); }, 1200);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', collect);
})();
